import React from "react";
import { Box } from "@mui/material";
import { t } from "@lingui/macro";
import { withSnackbar, WithSnackbarProps } from "notistack";
import {ContentProducerService} from "../../../services/content-producer-service";
import NavigationBack from "../../../commons/navigation/navigation-back/navigation-back";
import {ErrorResponseApi} from "../../../models/response";
import {CreateSubscriptionState} from "./models";
import {CreateSubscriptionRequest} from "../../../models/request/create-subscription";
import ZPlayLoader from "../../../commons/zplay-loader";
import { CreateAndEditSubscription } from "components/backoffice/subscription";


class CreateSubscription extends React.Component<WithSnackbarProps, CreateSubscriptionState> {


    constructor(props: any) {
        super(props);

        this.state={
            isLoading: false,
        }
    }

    private checkRequest = (request : CreateSubscriptionRequest):boolean =>{
        let errorsArray: string[] = [];

        if(request.name === "" || !request.name)
            errorsArray.push(t({
                id: "cs-no-name-create-subscription",
                message: "È necessario inserire il nome"
            }));

        if(request.monthlyPriceWithoutVAT === -1)
            errorsArray.push(t({
                id: "cs-no-monthly-price-create-subscription",
                message: "È necessario inserire il prezzo mensile"
            }));

        if(request.yearlyPriceWithoutVAT === -1)
            errorsArray.push(t({
                id: "cs-no-yearly-price-create-subscription",
                message: "È necessario inserire il prezzo annuale"
            }));


        if (errorsArray.length > 0)
            this.props.enqueueSnackbar(errorsArray.join(". "),
                { variant: "error" });

        return errorsArray.length === 0;

    }

    private submitForm = (request: CreateSubscriptionRequest) => {
        if(!this.checkRequest(request))
            return

        this.setState(() => ({
            isLoading: true
        }))
        ContentProducerService.createSubscription(request, this.createSubscriptionSuccessCallback, this.createSubscriptionErrorCallback);

    };


    createSubscriptionSuccessCallback = (data: any) => {
        this.setState(() => ({
            isLoading: false
        }))

        this.props.enqueueSnackbar(t({
            id: "cs-success-create-subscription",
            message: "L'abbonamento è stato creato"
        }), {
            variant: "success",
        })
    }

    createSubscriptionErrorCallback = (err: ErrorResponseApi) => {
        this.setState(() => ({
            isLoading: false,
        }));

        this.props.enqueueSnackbar(t({
            id: "cs-error-create-subscription",
            message: "Si è verificato un errore. Non è stato possibile creare l'abbonamento"
        }), {
            variant: "error",
        });
    }

    render() {
        return (
            <Box sx={{ p: 5 }}>
                {this.state.isLoading && <ZPlayLoader />}
                <NavigationBack/>
                <Box maxWidth={"1000px"} padding={"30px 10px 10px"} margin={"0 auto"}>
                    {!this.state.isLoading && <CreateAndEditSubscription
                        subscription={null}
                        onSubmit={this.submitForm}
                    />}
                </Box>
            </Box>
        );
    }
}

export default withSnackbar(CreateSubscription);